"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { getBotReason, isConfirmedBot } from "../lib/is-bot";
import { initMixpanelClient, type InitMixpanelOptions } from "../lib/mixpanel-client";
import { registerUtmSuperProperties } from "../../utm/lib/utm-attribution-client";

/**
 * Initialize Mixpanel early in the app lifecycle.
 * This ensures autocapture (pageviews, form submissions) works correctly.
 * Add this to your root layout.
 *
 * Bot detection runs client-side against `navigator.userAgent` rather than a
 * server-read `headers()` call — the header and `navigator.userAgent` carry
 * the same client-supplied value, so reading it server-side bought no extra
 * authority, only cost every page mounting this in its root layout static
 * rendering (a server component awaiting `headers()` forces the whole route
 * dynamic).
 *
 * `known_bot`/`automation_tool` still gate init; `missing_user_agent` is
 * shadow mode — tagged, not gated. See isConfirmedBot's doc comment.
 */
export default function MixpanelInit(t0) {
  const $ = _c(7);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    eventPrefix,
    recordSessionsPercent,
    identifyWithGaClientId
  } = t1;
  let t2;
  let t3;
  if ($[2] !== eventPrefix || $[3] !== identifyWithGaClientId || $[4] !== recordSessionsPercent) {
    t2 = () => {
      const botReason = getBotReason(navigator.userAgent);
      if (botReason && !isConfirmedBot(botReason)) {
        console.warn("[mixpanel] tagging suspected bot traffic (shadow mode)", {
          reason: botReason,
          userAgent: navigator.userAgent
        });
      }
      initMixpanelClient({
        eventPrefix,
        recordSessionsPercent,
        botReason,
        identifyWithGaClientId
      }).then(registerUtmSuperProperties);
    };
    t3 = [eventPrefix, recordSessionsPercent, identifyWithGaClientId];
    $[2] = eventPrefix;
    $[3] = identifyWithGaClientId;
    $[4] = recordSessionsPercent;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  return null;
}